import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShowHideLoaderService {
  private showloadder=new BehaviorSubject<boolean>(false); 
    
  loader = this.showloadder.asObservable();

  constructor() { }

  ShowHide(showhide: boolean){
    this.showloadder.next(showhide);
  }
}
